import http from './http';

export default {
  index(filter) {
    return http.get("/input_masks", {
      params: {
        ...filter
      }
    })
  }
}